var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'song-list-item': true, 'now-playing': _vm.nowPlaying}},[_c('p',{on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.song.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }